document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".categories-container");
  if (!container) return;

  let isDown = false;
  let startX;
  let scrollLeft;
  let isScrolling = false;

  // Scroll to active category immediately
  function scrollToActiveCategory() {
    const activeTab = document.querySelector(".category-item.active");
    if (activeTab) {
      const containerRect = container.getBoundingClientRect();
      const activeTabRect = activeTab.getBoundingClientRect();
      if (document.documentElement.dir === "rtl") {
        // RTL scrollLeft is negative, so centre the tab from its on-screen position.
        container.scrollLeft += activeTabRect.left + activeTabRect.width / 2 - (containerRect.left + containerRect.width / 2);
      } else {
        container.scrollLeft = activeTab.offsetLeft - (containerRect.width / 2 + activeTabRect.width / 2);
      }
    }
  }

  const anchorTags = container.querySelectorAll("a");

  anchorTags.forEach((anchor) => {
    anchor.setAttribute("draggable", "false");
  });

  // Handle mouse events for scrolling
  container.addEventListener("mousedown", (e) => {
    isDown = true;
    isScrolling = false; // Reset scroll tracking
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 2;

    if (Math.abs(walk) > 5) {
      // If movement exceeds 5px, treat it as scrolling
      isScrolling = true;
    }

    container.scrollLeft = scrollLeft - walk;
  });

  container.addEventListener("mouseup", () => {
    isDown = false;
    setTimeout(() => {
      isScrolling = false; // Reset after a short delay
    }, 100);
  });

  container.addEventListener("mouseleave", () => {
    isDown = false;
  });

  // Prevent clicks while scrolling
  document.querySelectorAll(".category-item").forEach((button) => {
    button.addEventListener("click", function (e) {
      if (isScrolling) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });

  const subcollectionFilter = container.matches("[data-subcollection-filter]") ? container : null;

  if (subcollectionFilter && typeof FacetFiltersForm !== "undefined") {
    subcollectionFilter.addEventListener("click", function (event) {
      const link = event.target.closest(".category-item");
      if (!link || isScrolling) return;

      event.preventDefault();
      const params = new URLSearchParams();
      const handle = link.dataset.subcollectionHandle;

      if (handle) params.set("subcollection", handle);

      FacetFiltersForm.renderPage(params.toString(), event);
    });

    document.getElementById("ProductGridContainer")?.addEventListener("click", function (event) {
      const paginationLink = event.target.closest(".pagination a");
      const activeSubcollection = subcollectionFilter.querySelector(".category-item.active[data-subcollection-handle]");

      if (!paginationLink || !activeSubcollection) return;

      event.preventDefault();
      const params = new URL(paginationLink.href).searchParams;
      params.set("subcollection", activeSubcollection.dataset.subcollectionHandle);
      FacetFiltersForm.renderPage(params.toString(), event);
      document.querySelector(".collection-hero")?.scrollIntoView({ behavior: "smooth" });
    });

    const initialParams = new URLSearchParams(window.location.search);
    if (initialParams.has("subcollection")) {
      FacetFiltersForm.renderPage(initialParams.toString(), null, false);
    }
  }

  // Run on load and on window resize
  setTimeout(scrollToActiveCategory, 0);
});

function handleCategoryClick(url) {
  window.location.href = url;
}
